module.exports = __webpack_public_path__ + "img/ic_fluent_location_20_regular.24abb877.svg";